<template>
  <div class="us_app">
    <section class="user_section">
      <article class="view intro" style="width: 800px">
        <div class="main_banner">
          <img src="@/assets/img/layout/health_center_documents.jpg" alt="" />
        </div>
        <a href="/data/file/health_center_filing_online.hwp" download="온라인신고양식.hwp"  class="button_app">
          <img
            src="@/assets/img/layout/application_button_1.png"
            alt=""
            style="width: 93%"
          />
        </a>
        <a href="https://www.hurb.or.kr/" target="_blank" class="button_app">
          <img
            src="@/assets/img/layout/application_button_2.png"
            alt=""
            style="width: 93%"
          />
        </a>
      </article>
    </section>
  </div>
</template>

<script>


export default {
  components: {

  },
  mounted() {},
  methods: {},
  data() {
    return {
      navTitle: ["커뮤니티", "공지사항"],
    };
  },
};
</script>
<style>
.button_app {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 30px;
}
</style>
